module.exports = __webpack_public_path__ + "static/img/chat_close.377d9e72.png";